import {ICustomerFile} from './customer-file.model';
import {IPhone} from './phone.model';
import {IOrderObject} from './order-object.model';
import {ITransaction} from './transaction.model';
import {IProject} from './project.model';
import {IUser} from "../../core/user/user.model";
import {IOrganization} from "./organization.model";
import {IEmployee} from "./employee.model";

export interface ICustomer {
  id?: number;
  customerId?: any;
  dashId?: number;
  address?: string;
  code?: string;
  behavior_type?: string;
  category?: string;
  deadline?: any;
  startDate?: any;
  city?: string;
  codeTarafHesab?: string;
  deleted?: string;
  description?: string;
  otherFeatures?: string;
  postalCode?: string;
  country?: string;
  state?: string;
  theMethodIntroduction?: string;
  title?: string;
  jalaliDate?: string;
  nationalId?: string;
  economicCode?: string;
  website?: string;
  isarchived?: boolean;
  isdeleted?: boolean;
  jhiType?: string;
  gender?: string;
  prefix?: string;
  email?: string;
  email2?: string;
  firstName?: string;
  lastName?: string;
  assign_list?: string;
  officeWork?: string;
  fieldActivity?: string;
  billing_points?: string;
  billingPoints?: string;
  level?: string;
  count_order?: string;
  max_date?: any;
  amount_order?: any;
  methodIntroduction?: string;
  connector?: string;
  status?: string;
  status_2?: string;
  phones?: IPhone[];
  orderObjects?: IOrderObject[];
  transactions?: ITransaction[];
  customerFiles?: ICustomerFile[];
  projects?: IProject[];
  users?: IUser[];
  employees?: IEmployee[];
  organization?: IOrganization;
  employees_set?: any[];
  employeeId?: any;
  employeeId_search?: any;
  lastModifiedBy?: any;
  createdDate?: any;
  lastModifiedDate?: any;
  last_modified_date?: any;
  created_date?: any;
  created_by?: any;
  createdBy?: any;
}

export class Customer implements ICustomer {
  constructor(public id?: number,
              public address?: string,
              public customerId?: any,
              public code?: string,
              public gender?: string,
              public prefix?: string,
              public email?: string,
              public email2?: string,
              public firstName?: string,
              public lastName?: string,
              public behavior_type?: string,
              public category?: string,
              public city?: string,
              public codeTarafHesab?: string,
              public deleted?: string,
              public deadline?: any,
              public startDate?: any,
              public employees_set?: any[],
              public employeeId?: any,
              public employeeId_search?: any,
              public isarchived?: boolean,
              public isdeleted?: boolean,
              public description?: string,
              public otherFeatures?: string,
              public postalCode?: string,
              public jalaliDate?: string,
              public country?: string,
              public state?: string,
              public theMethodIntroduction?: string,
              public connector?: string,
              public title?: string,
              public website?: string,
              public jhiType?: string,
              public assign_list?: string,
              public officeWork?: string,
              public fieldActivity?: string,
              public methodIntroduction?: string,
              public status?: string,
              public status_2?: string,
              public phones?: IPhone[],
              public orderObjects?: IOrderObject[],
              public transactions?: ITransaction[],
              public customerFiles?: ICustomerFile[],
              public users?: IUser[],
              public organization?: IOrganization,
              public lastModifiedBy?: any,
              public lastModifiedDate?: any,
              public createdDate?: any,
              public created_by?: any,
              public createdBy?: any,
              public projects?: IProject[]) {
    this.country = 'ايران';
    this.isarchived = false;
    this.isdeleted = false;
    this.employees_set = employees_set ? employees_set : null;


  }
}
